import { render, staticRenderFns } from "./salesreceipt.vue?vue&type=template&id=68a9a0fe&"
import script from "./salesreceipt.vue?vue&type=script&lang=js&"
export * from "./salesreceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports